import React from "react"

import {Card, CardContent, CardHeader, CardTitle} from "@/components/ui/card"
import {Table, TableBody, TableCell, TableHead, TableHeader, TableRow} from "@/components/ui/table"

interface SimilarSegmentTableProps {
    message: string
}

interface SegmentData {
    name: string
    description: string
    maxDistance: number
    additional: {
        distance: number
    }
    [key: string]: any // Allow other properties but we won't use them
}

const SimilarSegmentTable: React.FC<SimilarSegmentTableProps> = ({message}) => {
    try {
        const data = JSON.parse(message) as SegmentData[]

        if (!Array.isArray(data) || data.length === 0) {
            return (
                <Card>
                    <CardHeader>
                        <CardTitle>No segment data to display</CardTitle>
                    </CardHeader>
                </Card>
            )
        }

        return (
            <Card>
                <CardHeader>
                    <CardTitle>Similar Segments</CardTitle>
                </CardHeader>
                <CardContent className="p-4">
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead className="font-semibold text-right">Similarity to Generated Segment</TableHead>
                                <TableHead className="font-semibold">Name</TableHead>
                                <TableHead className="font-semibold">Description</TableHead>
                                <TableHead className="font-semibold text-right">Max Distance</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {data.map((segment, index) => (
                                <TableRow key={index}>
                                    <TableCell className="text-right">{(100 - 100 * segment._additional?.distance).toFixed(1)}%</TableCell>
                                    <TableCell className="font-medium">{segment.name}</TableCell>
                                    <TableCell>{segment.description}</TableCell>
                                    <TableCell className="text-right">{segment.maxDistance.toFixed(2)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
        )
    } catch (error) {
        return (
            <Card>
                <CardHeader>
                    <CardTitle>Invalid segment data</CardTitle>
                </CardHeader>
            </Card>
        )
    }
}

export default SimilarSegmentTable
